import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './full-page-image-banner.component.scss';
var FullPageImageBanner = /** @class */ (function (_super) {
    tslib_1.__extends(FullPageImageBanner, _super);
    function FullPageImageBanner(element) {
        return _super.call(this, element) || this;
    }
    FullPageImageBanner.prototype.init = function () {
        // if(this.element.closest('.col-12')) {
        // 	this.element.classList.add('fixed');
        // }
    };
    FullPageImageBanner.prototype.bindEvents = function () {
    };
    return FullPageImageBanner;
}(Base));
export { FullPageImageBanner };



//////////////////
// WEBPACK FOOTER
// ./components/full-page-image-banner/full-page-image-banner.component.ts
// module id = 335
// module chunks = 0